import { useMemo } from 'react'
import { useLanguage } from '../../../../../stores/LanguageStore';
import { Text, Tooltip } from '@mantine/core';
import { parseDate, parseDateFuture } from '../../../../../functions/dates';
import { getCallColor, getDifference, reminderTypes } from '../../utils';

const PrmCellCalls = ({ row, onClick }) => {
  const difference = useMemo(() => {
    return getDifference(row?.calls[0]?.call_date);
  }, [row?.calls]);

  return (
    row.calls.length > 0 && (
      <Tooltip label={row.calls[0]?.name}>
        <Text
          c={getCallColor(row.calls[0]?.call_date)}
          size="xs"
          fw={500}
          onClick={onClick}
        >
          {reminderTypes()[row.calls[0]?.type]}:{" "}
          {difference.result < 0
            ? parseDate(row.calls[0]?.call_date, false)
            : parseDateFuture(row.calls[0]?.call_date)}
        </Text>
      </Tooltip>
    )

  )
}

export default PrmCellCalls